import { render, staticRenderFns } from "./NoEvents.vue?vue&type=template&id=6628736c&"
import script from "./NoEvents.vue?vue&type=script&lang=js&"
export * from "./NoEvents.vue?vue&type=script&lang=js&"
import style0 from "./NoEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports